import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import { formatPrice } from '../../utils/format';
import useStyles from './styles';

export default function OrderButton() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const count = useSelector(state => state.order.order.items.length);
  const total = formatPrice(
    useSelector(state =>
      state.order.order.items.reduce((sumtotal, item) => {
        return sumtotal + item.amount * item.price;
      }, 0)
    )
  );

  function handleOrder() {
    dispatch({ type: '@order/SHOW' });
  }

  return (
    <Fab
      variant="extended"
      color="primary"
      aria-label="add"
      className={classes.button}
      onClick={handleOrder}
    >
      <Typography className={classes.title}>{count}</Typography>
      <Typography className={classes.title}>Ver pedido</Typography>
      <Typography className={classes.title}>{total}</Typography>
    </Fab>
  );
}
